import React from 'react';

import { useTheme } from '@mui/material/styles';

import RotateRightIcon from '@mui/icons-material/RotateRight';
import StopIcon from '@mui/icons-material/Stop';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const StopActionButton = (props: IBaseActionButtonProps) => {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <BaseActionButton {...props}>
      <StopIcon />
    </BaseActionButton>
  );
};

export default StopActionButton;
